<template>
  <article :class="['detail-page']">
    <!-- <page-header
		:titleText='titleText'
		:showGoBack="showGoBack"
		></page-header> -->
    
    <section :class="['detail-page-container']">
      <swiper
      :swiperImgArray="detailSwiperImg"
      :swiperWrapClass="swiperClass"
      ></swiper>
      <!-- :autoPlay = "autoplay" -->
      <div class="describe">
        <h3>{{goodsInfo.ScopeName}}</h3>
        <p class="">
          <span class="">会员价 :<i class="iconfont icon-renminbi"></i>{{goodsInfo.AdultPrice}}</span>
          <span class="yuanjia">原价 :<i class="iconfont icon-renminbi"></i>{{goodsInfo.AdultPrice*1.15}}</span>
        </p>
        <p class=""><span>{{goodsInfo.Remarks}}</span></p>
      </div>
      <div @click="triggerMask" class="option_btn">
        <span>选择:机场</span>
        <i class=" iconfont icon-iconfontzhizuobiaozhun19"></i>
      </div>
      <div class="details">
        <!-- <div class="article-news" v-html="news"></div> -->
        <!-- <div class="addArticle">

          <h3>珠海机场（车型：红旗H7）</h3>
          <p>中山城区/镇区-机场往返专车 ￥500元</p>
          <p>中山城区/镇区-机场单程专车 ￥350元</p>
          <p>机场-中山城区/镇区单程专车 ￥350元</p>

          <h3>广州机场（车型：红旗H7）</h3>
          <p>中山城区/镇区-机场往返专车 ￥700元</p>
          <p>中山城区/镇区-机场单程专车 ￥450元</p>
          <p>机场-中山城区/镇区单程专车 ￥450元</p>

          <h3>深圳机场（车型：红旗H7）</h3>
          <p>中山城区/镇区-机场单程专车 ￥800元</p>
          <p>中山城区/镇区-机场单程专车 ￥500元</p>
          <p>机场-中山城区/镇区单程专车 ￥500元</p>

          <h3>佛山机场（车型：红旗H7）</h3>
          <p>中山城区/镇区-机场单程专车 ￥350元</p>
          <p>中山城区/镇区-机场单程专车 ￥350元</p>

          <h3>广州南站（车型：红旗H7）</h3>
          <p>中山城区/镇区-南站往返专车 ￥500元</p>
          <p>中山城区/镇区-南站单程专车 ￥300元</p>
          <p>南站-中山城区/镇区单程专车 ￥300元</p>

          <h3>客服联系电话：</h3>
          <p>18029902100（邓先生）</p>
          <p>18029902235（钱小姐）</p>
          <p>18029902001（蔡小姐）</p>
          <p>18029902098（何小姐）</p>
          <p>0760-88880777 （08:00-18:30）</p>

          <span>（往返套餐的返程可指定日期）</span>
          <span>所有预约需提前一天17:00前购买</span>
          <p class="red-text">下单成功后，司机信息会在行程出发前1-2天落实，购买成功后请保持联系电话畅通。</p>

          <span class="jiashou">【加收说明】</span>
          <p>◆定制包车24小时出发，深夜时段：22:00至次日凌晨05:00时间段内出发或到达的加收50元/程。</p>
          <p>◆定制包车适用于中山市所有范围。</p>
          <p>往广州南站、广州机场、深圳机场方向的，三乡镇、神湾镇、坦州镇需加100元，南朗镇、板芙镇、五桂山镇加50元。</p>
          <p>往珠海机场方向的，古镇镇、小揽镇、南头镇、黄圃镇、东凤镇、三角镇、阜沙镇、民众镇需加70元，横栏镇、南朗镇加30元。</p>
          <p>如果婚车、组织的会议等，在会场外面排着的都是一排排的红旗轿车，场面不要太酷炫了吧~</p>
          <img src="static/img/1.jpg" alt="">
          <p>红旗，对于中国人而言，不仅是一个标识，还是一种深深的情怀和神圣的记忆。生在新中国，长在红旗下，终于有幸见识到庐山真面目了。中山候机楼推出一站式机场定制包车服务，服务轿车就是这看似离我们遥不可及的红旗轿车。</p>
          <img src="static/img/2.jpg" alt="">
          <p>提供各大机场接送机服务，专为商务公司、航空公司、旅行社等【涉旅企业】提供一站式机场出行解决方案。接送机范围覆盖全中山市哦~</p>
          <img src="static/img/3.jpg" alt="">
          <p>此次中山候机楼接入机场定制包车服务，无需靠站，一站式出行，礼遇快捷、安全、可靠、舒适！让奔波的旅途中，发现更多出行的专属惠益与宽适尊享！</p>
          <p>赶快来pick你心中那款自豪、神圣~想乘坐却一直没机会的红旗车，尽享轻松无忧之旅吧！</p>
          <img src="static/img/4.jpg" alt="">

        </div> -->
      </div>

    </section>

    <page-footer
    :btnText="footBtnText"
    :goodsPrice="goodsPrice"
    :go_mask="go_mask"
    @triggerMask="triggerMask($event)">
    </page-footer>

    <mask-options :showMask="showMask" @triggerMask="triggerMask($event)"></mask-options>

  </article>
</template>

<script>

  import Header from '@/components/child-components/Header'
  import Swiper from './child-components/Swiper'
  import Footer from './child-components/Footer'
  import Mask from './child-components/Mask'
  // import store from '@/vuex/store.js'

  export default {
    name: 'detail-page',
    // store,
    data() {
      return {
        // detailSwiperImg:[
        //   "static/img/1.jpg",
        //   "static/img/2.jpg",
        //   "static/img/3.jpg",
        //   "static/img/4.jpg",
        // ],
        detailSwiperImg: [
          {id: 1,src: "static/img/1.jpg",to: ""},
          {id: 2,src: "static/img/2.jpg",to: ""},
          {id: 3,src: "static/img/3.jpg",to: ""},
          {id: 4,src: "static/img/4.jpg",to: ""}
        ],
        swiperClass: "dtail-page-swiper",
        autoplay: false,
        titleText: "中山城市候机楼",
        logoImg: false,
        showGoBack: true,
        //foot-parameter
        footBtnText: "立即购买",
        goodsPrice: false,
        go_mask: true,
        // mask--------------
        showMask: false,
        // article news-------------
        news: "",
        // goods--------------
        goodsInfo:{},

        // $route
        goodsId:"",
      }
    },
    components: {
      "page-header": Header,
      "swiper": Swiper,
      "page-footer": Footer,
      "mask-options": Mask,
    },
    methods: {
			// changeVX(){
			//   store.commit('subCount');
			// },
      triggerMask() {
        this.showMask = !this.showMask;
      },
      getRouterDataId(){
        if (this.$route.query.goodsId) {
          this.goodsId = this.$route.query.goodsId;
        	// console.log(this.$route.query.id);
        } else {
            alert("参数异常,返回重试");
            this.$router.go(-1);
        	}
      },
      getGoodsInfo(goodsId){
        this.$http.get("https://www.callmefix.net/api/scopegoods/getScopeGoodsInfo",{
          params:{
            goodsid:goodsId,
          }
        }).then((res)=>{
          if (res.data.success) {
            this.goodsInfo = res.body.data;
            console.log(res);
            console.log(this.goodsInfo);
          }else{
            alert('获取商品信息失败!');
            this.$router.go(-1);
          }
        })
      }
    },
    created() {
    },
    activated(){
      this.getRouterDataId();
      this.getGoodsInfo(this.goodsId);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="scoped" lang="less">
  @import '.././style/variable';

  .detail-page-container {
    flex: 1;
    .overfA();
  }

  .describe,
  .option_btn,
  .details {
    background-color: #fff;
    padding: 3%;
    margin-bottom: 10px;
  }

  .describe {
    .yuanjia {
      .gray-text();
      .line-thr();
      margin-left: 5px;
    }

    .iconfont {
      margin: 0;
    }

    h3,
    .jiashou {
      font-size: .45rem;
      font-weight: 400;
    }

    &>p:first-of-type {
      margin-top: .2rem;
      font-size: .4rem;
      .red-text();
    }

    &>p:last-of-type {
      .gray-text();

      &>span {
        margin-right: 5px;
      }
    }

  }

  .details {
    p {
      font-size: .4rem;
    }

    &>span {
      display: block;
      text-align: center;
      color: #e22222;
      font-size: .4rem;
    }

    .jiashou {
      font-weight: 600;
      color: #fff;
      background-color: rgb(52, 109, 171);
      font-size: .45rem;

    }

    .addArticle {
      .flex_wrap(initial, center, nowrap, column);
      color: #555;
      &>h3,
      &>p {
        margin: 4px auto;
      }

      &>h3 {
        font-weight: 600;
        background-color: yellow;
        font-size: .45rem;
        line-height: .6rem;
        text-indent: .6em;
        text-align: center;
      }
    }

    &>h3 {
      font-size: .42rem;
      font-weight: 600;
      text-align: center;
    }

    &>p {
      text-indent: 2em;
      .padding-Lr();
      .margin-Tb();
    }

    img {
      display: block;
      width: 95%;
      height: auto;
      margin: .5rem auto;
    }
  }

  .option_btn {
    .flex_wrap(space-between, center, nowrap, initial);

    span {
      font-size: @fz;
    }

    .iconfont {
      font-size: @fz+.07rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailPage.vue